import axios from "axios";
import React, { useState } from "react";
import { awsUrl2 } from "../../config";
import LoadingOverlay from "react-loading-overlay";

function ExistingToNewBusiness(props) {
  const { rowData, updatePopUpData, updateConfirmDealMap, handleDealConfirm } =
    props;

  let { user_email_id, quoteData, address } = rowData;
  const [isLoading, setIsLoading] = useState(false);

  let handleConfirmClick = async () => {
    updatePopUpData({
      show: true,
      title: "Do you wish to move this deal to New Business?",
      children: (
        <>
          <br></br>
          <span style={{ fontWeight: "bold" }}>
            This action will move the submission to the respective tab.
          </span>
        </>
      ),
      acceptBtn: "Yes",
      acceptBtnCallback: async () => {
        await performConfirmation();
      },
    });
  };

  const performConfirmation = async () => {
    setIsLoading(true);

    try {
      let childrenLoc = rowData?.childrenLoc;

      if (childrenLoc) {
        Object.values(childrenLoc).forEach((location) => {
          if (location.isNewAddition) {
            location.isNewAddition = false;
          }
          if (location.classCodesInfo) {
            Object.values(location.classCodesInfo).forEach((classCode) => {
              if (classCode.isNewAddition) {
                classCode.isNewAddition = false;
              }
            });
          }
        });
      }

      let userRequestBody = {
        user_email_id,
        deal_confirmed: false,
        endorsementMeta: null,
        childrenLoc,
      };

      let promiseList = [
        axios.post(awsUrl2 + "/api/userTableData/update", userRequestBody),
      ];

      if (quoteData) {
        let { uuid, date } = quoteData;
        let quoteRequestBody = {
          user_email_id,
          timestamp: date,
          peo: "ies",
          address,
          uuid,
          deal_confirmed: false,
        };

        promiseList.push(
          axios.post(awsUrl2 + "/api/updateUserStatusTable", quoteRequestBody)
        );
      }

      await Promise.all(promiseList)
        .then((res) => {
          setIsLoading(false);
          if (updateConfirmDealMap) {
            updateConfirmDealMap(user_email_id, false);
          }
          if (handleDealConfirm) {
            handleDealConfirm(rowData);
          }
        })
        .catch((err) => {
          console.error("Error in confirmation promises:", err);
          setIsLoading(false);
        });
    } catch (e) {
      console.error("Error while updating", e);
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoadingOverlay active={isLoading}>
        <button
          style={{
            fontSize: "12px",
            backgroundColor: "#FFCD4D",
            borderRadius: "4px",
            border: "1px solid #FFCD4D",
          }}
          onClick={handleConfirmClick}
        >
          Confirm
        </button>
      </LoadingOverlay>
    </>
  );
}

export default React.memo(ExistingToNewBusiness);
